import { Alert, Button } from 'react-bootstrap';
import React, { useEffect, useCallback, memo, useState } from 'react';
import ReactDOM from 'react-dom';

import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Flex } from '../../Layout';

import { toggleFixedAlert } from '../../../redux/actions/general';

import './_back-ticket.scss';
import './_back-ticket.dark-mode.scss';

const alertHeight = '40px';

const BackTicket = () => {
  const wrapperAlerts = typeof document !== 'undefined'
    ? document.getElementById('wrapper-alerts')
    : null;

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const showFixedAlert = useSelector((state) => state.general.showFixedAlert);
  const backPath = useSelector((state) => state.general.backPath);
  const [showAlertPath, setShowAlertPath] = useState(null);

  useEffect(() => {
    if (showFixedAlert && !showAlertPath) {
      setShowAlertPath(location.pathname);
    } else if (!showFixedAlert) {
      setShowAlertPath(null);
    }
  }, [showFixedAlert]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showAlertPath && showAlertPath !== location.pathname) {
      dispatch(toggleFixedAlert(false, ''));
    }
  }, [location.pathname, showAlertPath, dispatch]);

  const handleBackClick = useCallback(() => {
    history.push(backPath || '/tickets');
  }, [backPath, history]);

  if (!showAlertPath) return null;

  return (
    <>
      <Alert
        bsStyle="info"
        className="fixed-alerts__back-ticket cursor-pointer"
      >
        <Flex align="center" justify="center">
          <Button
            block
            bsStyle="link"
            onClick={handleBackClick}
            aria-label="Back to ticket"
            style={{ height: alertHeight }}
          >
            <span>‹</span>
            Back to ticket
          </Button>
        </Flex>
      </Alert>
      {wrapperAlerts && ReactDOM.createPortal(
        <div style={{ height: alertHeight }} />,
        wrapperAlerts,
      )}
    </>
  );
};

export default memo(BackTicket);
